module.exports = __webpack_public_path__ + "img/speak2.a937e27f.png";